import { KypDateField, KypFilters } from 'data/models/Kyp';

//ToDo: Remove when icon logic is consolidated
export const fileExtensionToMimeMap: Record<string, string> = {
  // Documents
  pdf: 'application/pdf',
  txt: 'text/plain',
  html: 'text/html',
  htm: 'text/html',
  xml: 'application/xml',
  json: 'application/json',

  // Images
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  gif: 'image/gif',
  bmp: 'image/bmp',
  webp: 'image/webp',
  svg: 'image/svg+xml',
  ico: 'image/x-icon',
};

export const initialKypFilters: KypFilters = {
  type: null,
  reviewStatus: null,
  approvedFor: null,
  partner: null,
  filteringDate: 'Last Updated',
  startDate: null,
  endDate: null,
  isExpired: null,
};

export const kypFilterDateOptionToDateKeyMap: Record<string, KypDateField> = {
  'Last Updated': 'lastUpdated',
  'Last Reviewed': 'reviewDate',
  Created: 'startTime',
};
